import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../contexts/PermissionContext';
import { Loading } from './Loading';

/**
 * Restricts children to the client portal shell — only Patient / RelatedPerson client sessions (`rbac.isClient`).
 */
export function RequireClientRole({ children }: { children: ReactNode }): JSX.Element {
  const rbac = usePermissions();

  if (!rbac.ready) {
    return <Loading />;
  }

  if (!rbac.isClient) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
